class SectionContentWithVideo {
    constructor() {

        let modal = document.querySelectorAll(".modal-video");
        let openModal = document.querySelector(".block-image.hasvideo img");
        let closeModal = document.querySelector(".backshadow");
        let closeModalBtn = document.querySelector(".close-modal");

        if (openModal) {
            openModal.addEventListener('click', function(event) {
                event.preventDefault();
                modal[0].classList.add('show');
            });
        }

        if (closeModal) {
            closeModal.addEventListener('click', function(event) {
                event.preventDefault();
                modal[0].classList.remove('show');
            });
        }

        if (closeModalBtn) {
            closeModalBtn.addEventListener('click', function(event) {
                event.preventDefault();
                modal[0].classList.remove('show');
            });
        }
    }
}

export default SectionContentWithVideo;